export interface MarketingSource {
    deleted: boolean;
    _id: string;
    MarketingID: number;
    SiteID: number;
    prefix: string;
    sLocationCode: string;
    OldPK: number;
    __v: number;
    bPermanent: boolean;
    sDefMarketingDesc: string;
    sMarketingDesc: string;
    sMktgDistanceDesc: string;
    sMktgTypeDesc: string;
    sMktgWhatDesc: string;
    sMktgWhyDesc: string;
    sMktgReasonDesc: string;
    uTS: string;
}

export const groupByLocationCode = (marketingSources: MarketingSource[]) => {
    return marketingSources.reduce(
        (acc, marketingSource) => {
            if (!acc[marketingSource.sLocationCode]) {
                acc[marketingSource.sLocationCode] = [];
            }
            acc[marketingSource.sLocationCode].push(marketingSource);
            return acc;
        },
        {} as Record<string, MarketingSource[]>,
    );
};

export interface MarketingSurveyPayload {
    tenantId: number;
    survey: {
        whereHearAboutUs?: number;
        distanceFromFacility?: number;
        whyStoring?: number;
        customerType?: number;
        whatStoring?: number;
        whyStoringWithUs?: number;
    };
}
